import TextEditorMinimal from '@/components/commons/minimal-tiptap/minimal-editor';
import { ScrollingTextElementDataType } from '@/components/sections/builder/elements/body/scrolling-text/types';
import { ElementProps } from '@/components/sections/builder/types';
import { useBuilderStore } from '@/stores/builder';
import clsx from 'clsx';
import { Type } from 'lucide-react';
import { shallow } from 'zustand/shallow';

type ElementDataType = {
  name: string;
  label: string;
};

const defaultData: ElementDataType = {
  name: 'Scrolling Text Item',
  label:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua',
};

export const ElementContent = ({ element }: ElementProps) => {
  const data = (element.data || defaultData) as ElementDataType;

  const content = element.data as ScrollingTextElementDataType;

  return (
    <>
      <span
        className={clsx(
          'line-clamp-1 inline-block',
          content.colorSchemeScrollingText?.text && 'font_color_text'
        )}
        dangerouslySetInnerHTML={{ __html: data.label }}
      />
      <style jsx>
        {`
          .font_color_text {
            color: ${content.colorSchemeScrollingText?.background || 'white'};
          }
        `}
      </style>
    </>
  );
};

export const ElementPreviewIcon = Type;

export function ElementSetting({ element }: ElementProps) {
  const builder = useBuilderStore(
    (state) => ({
      setChildData: state.setChildData,
    }),
    shallow
  );

  const data = (element.data || defaultData) as ElementDataType;

  return (
    <div>
      <div className='mb-4 mt-4 font-bold'>Label</div>
      <TextEditorMinimal
        onChange={(val) => {
          builder.setChildData(element.parentId as string, element.id, { label: val });
        }}
        output='html'
        className='mb-2 w-full '
        value={data.label}
        editorProps={{
          attributes: {
            class: 'prose lg:prose-lg prose-blue dark:prose-invert p-2',
          },
        }}
        editable
        placeholder='Button Title'
      />
    </div>
  );
}

const ScrollingTextItem = {
  type: 'scrolling_text_item',
  group: 'scrolling_text',
  defaultData,
  Element: ElementContent,
  Setting: ElementSetting,
  PreviewIcon: ElementPreviewIcon,
  Icon: ElementPreviewIcon,
  childs: [],
};

export default ScrollingTextItem;
